// extracted by mini-css-extract-plugin
export default {"slider":"vaOcW","slider-short":"_1Gc-1","sliderShort":"_1Gc-1","slider-adoptables":"_1Zx7p","sliderAdoptables":"_1Zx7p","slider-item":"kJq1Z","sliderItem":"kJq1Z"};